export const buildNominalOptions = (nominals = []) =>
  (nominals || [])
    .map(nominal => ({
      label: nominal.label,
      value: nominal.id,
      isInactive: nominal.active === 0,
    }))
    .sort(
      (first, second) => Number(first.isInactive) - Number(second.isInactive),
    );

const styleNominal = (base, { data }) => ({
  ...base,
  ...(data.isInactive ? { color: "#888888" } : {}),
});

export const nominalSelectStyles = {
  option: styleNominal,
  singleValue: styleNominal,
};
